module.exports = __webpack_public_path__ + "static/media/DataCentresLogo-nobg.347a7be2.png";